import { get, del, put, post } from 'aws-amplify/api';
import { replaceNullsWithEmpty } from '../utils/utils';
import { DealerDocument } from '../models/dealer-document.model';
import { CreateDealerDocument, CreateDealerDocumentSchema } from '../models/createDealerDocument.model';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const createDealerDocument = async (createDealerDocument: CreateDealerDocument) => {
  const createDealerDocumentBody = mapToRequest(createDealerDocument);
  const response = await post({
    apiName: 'dealer-documents',
    path: '/dealer-documents',
    options: { body: createDealerDocumentBody },
  }).response;

  const json = (await response.body.json()) as any;
  return json;
};

export const getDealerDocuments = async (filters: {
  name?: string;
  status?: string;
  dealerId?: string;
  limit?: number;
  lastKey?: string;
}): Promise<{ items: DealerDocument[]; lastKey: string }> => {
  const limit = filters.limit ?? 25;
  const lastKey = filters.lastKey ?? '';
  const name = filters.name ?? '';
  const status = filters.status ?? '';
  const dealerId = filters.dealerId ?? '';
  const response = await get({
    apiName: 'dealer-documents',
    path: `/dealer-documents?limit=${limit}&lastKey=${lastKey}&status=${status}&name=${name}&dealerId=${dealerId}`,
  }).response;
  const json = (await response.body.json()) as any;
  return {
    items: json.items.map((a: any) => mapFromResponse(a)),
    lastKey: json.lastKey,
  };
};

export const getDealerDocument = async (dealerDocumentId: string): Promise<DealerDocument> => {
  const response = await get({ apiName: 'dealer-documents', path: `/dealer-documents/${dealerDocumentId}` }).response;
  const json = (await response.body.json()) as any;
  return mapFromResponse(json);
};

export const updateDealerDocument = async (dealerDocument: DealerDocument): Promise<void> => {
  await put({
    apiName: 'dealer-documents',
    path: `/dealer-documents/${dealerDocument.id}`,
    options: { body: mapToRequest(dealerDocument) },
  }).response;
};

export const deleteDealerDocument = async (dealerDocumentId: string): Promise<void> => {
  await del({ apiName: 'dealer-documents', path: `/dealer-documents/${dealerDocumentId}` }).response;
};

const mapFromResponse = (dealerDocument: any): DealerDocument => {
  const res: DealerDocument = {
    ...dealerDocument,
  };
  return replaceNullsWithEmpty(res);
};

const mapToRequest = (dealerDocument: CreateDealerDocument | DealerDocument): any => {
  const newDealerDocument = { ...dealerDocument, date: dayjs(dealerDocument.date).utc().startOf('day').toDate() };
  const resParse = CreateDealerDocumentSchema.safeParse(newDealerDocument);
  if (resParse.success) {
    return resParse.data;
  }
  console.log(resParse.error);

  throw new Error('Validation error');
};
